import { DateFormat, formatDate } from './casMoment';

/**
 * Display value for an endorsement's "Is Fwd Contract?" field.
 *
 * Forward contract with a date -> the date; without one -> 'Yes'.
 * Not a forward contract -> '' (the blank the checkmark render already left).
 */
export default function formatFwdContract(
  isFwdContract: boolean | number | null | undefined,
  forwardContractDate: string | Date | null | undefined
) {
  // Only the set flag counts - anything else is treated as "not a forward contract".
  // Matches the backend's FwdContractHelper.FormatFwdContract().
  if (isFwdContract !== 1 && isFwdContract !== true) return '';
  return formatDate(forwardContractDate, DateFormat.MDY) || 'Yes';
}
